(function($) {
    var home = $('body.home');
    
    if (home.length) {
      // Default behaviour
      ScrollReveal({
        delay: 100,
      });

      // Let home sections slide in from the bottom
      ScrollReveal().reveal(
        '.home-section',
        {
          delay: 50,
          duration: 1200,
          opacity: 0,
        }
      );

      // Home section content is revealed depending on its type.
      // Cards
      ScrollReveal().reveal(
        '.card, .featured-article, .feature',
        {
          delay: 300,
          interval: 100,
          scale: 0.6,
        }
      );
      
      ScrollReveal().reveal(
        '.partners .partner',
        {
          interval: 300,
          opacity: 0,
          scale: 0.6,
          duration: 1200,
        }
      );
    }

})(jQuery);
